import { render } from "./AjustesPlay.vue?vue&type=template&id=4e6f476a&scoped=true"
import script from "./AjustesPlay.vue?vue&type=script&lang=js"
export * from "./AjustesPlay.vue?vue&type=script&lang=js"

import "./AjustesPlay.vue?vue&type=style&index=0&id=4e6f476a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6f476a"]])

export default __exports__